module.exports = __webpack_public_path__ + "img/qr1.2284292b.png";